/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LabelingReport_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"LabelingReportTable_viewer">;
    readonly " $refType": "LabelingReport_viewer";
};
export type LabelingReport_viewer$data = LabelingReport_viewer;
export type LabelingReport_viewer$key = {
    readonly " $data"?: LabelingReport_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"LabelingReport_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "LabelingReport_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "LabelingReportTable_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'c19fc76aa3762612c312fcb1a409be41';
export default node;
